module.exports = __webpack_public_path__ + "img/precise-mortgages-logo.fbd72b29.png";